<template>
  <div>
    <span class="d-flex mx-4 my-4">
      <v-spacer />
      <div class="mt-3 ml-8">
        <v-icon class="text-h4 mb-3">mdi-barn</v-icon>
        <span class="text-h5 ml-2">Farm: {{currentFarm}}</span>
        <div v-if="this.currentFarm == null">
          Please go to <a @click="goToSettingsPage()">settings</a>
          and set the default farm.
        </div>
      </div>
      <v-spacer />
      <v-btn
        fab
        color="accent"
        @click="addGroup()">
        <v-icon class="white--text text-h4">mdi-playlist-plus</v-icon>
      </v-btn>
    </span>

    <div class="d-flex flex-wrap justify-center">
      <v-card v-if="eggVisionGroups.length === 0"
        class="ma-2 pa-10"
        width="356"
        color="cardbackground">
        <div>No Groups found.</div>
      </v-card>
      <v-card v-else v-for="(item, index) in eggVisionGroups" :key="item.groupName + item.date"
          class="py-0 ma-2"
          max-width="342"
          color="cardbackground">
        <v-list-item class="pl-1">
          <v-list-item-content class="pt-1">
            <v-list-item-title class="text-h6 mb-0">
              <span>
                <v-btn icon @click="toggleCardDetails(index)">
                  <v-icon>{{ showDetail[index] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
              </span>
              <a @click="toggleCardDetails(index)">{{ item.groupName }}</a>
            </v-list-item-title>
            <v-list-item-subtitle class="ml-9">Vision Tray Count: {{item.trays ? item.trays.length : 0}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-card-actions class="px-3 pb-3">
          <v-btn
            :disabled="item.farm != currentFarm"
            x-large
            color="primary"
            class="pl-1 pr-3 mr-1"
            @click="goToCollectionPage(item)">
              <v-icon color="#F8F0E3">mdi-egg</v-icon><span>Collect</span>
          </v-btn>

          <v-btn
            fab
            class="ml-1"
            color="warning"
            :disabled="item.farm != currentFarm || isUploadDisabled(item)"
            @click="selectedGroup = item; showUploadDialog = true">
            <v-icon>mdi-upload</v-icon>
          </v-btn>

          <v-btn
          :disabled="item.farm != currentFarm"
            fab 
            color="success"
            @click="editGroup(item)">
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>

          <v-btn
              fab
              color="secondary"
              :disabled="isDeleteGroupDisabled(item)"
              @click="confirmDeleteGroup(item)">
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
        </v-card-actions>

        <v-expand-transition>
          <div v-show="showDetail[index]">
            <v-divider></v-divider>

            <v-card-text>
              <div class="primary--text text-subtitle-1">Details</div>
              <table class="ml-2">
                <tr><td><b class="pr-1">Farm:</b></td><td>{{item.farm}}</td></tr>
                <tr><td><b class="pr-1">Line:</b></td><td>{{item.line}}</td></tr>
                <tr><td><b class="pr-1">S MG:</b></td><td>{{item.mg}}</td></tr>
                <tr><td><b class="pr-1">Created:</b></td><td>{{formatDate(item.date)}}</td></tr>
                <tr><td><b class="pr-1">Operator:</b></td><td>{{item.operator}}</td></tr>
                <tr><td><b class="pr-1">Notes:</b></td><td>{{item.notes}}</td></tr>
                <tr><td><b class="pr-1">ClientUid:</b></td><td class="truncate">{{item.clientUid}}</td></tr>
              </table>
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
    </div>

    <v-dialog v-model="showModifyDialog" persistent max-width="400px">
      <v-card color="cardbackground">
        <v-card-title>
          <div class="headline" v-if="editItem.oldGroupName === null">Create Group</div>
          <div class="headline" v-else>Modify Group</div>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="6">
               <v-text-field
                readonly
                :value = "formatDate(editItem.date)"
                label="Collection Date"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                disabled
                v-model="editItem.farm"
                label="Farm"
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="editItem.line"
                label="Line *"
                :items="lines"
                :disabled="lines.length === 0"
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="editItem.mg"
                label="Source MG *"
                :items="mgs"
                :disabled="mgs.length === 0"
              />
            </v-col>
            <!-- <v-col cols="6">
              <v-select
                v-model="editItem.house"
                label="House *"
                :items="houses"
                :disabled="houses.length === 0"
              />
            </v-col> -->
            <v-col cols="6">
              <v-select
                v-model="editItem.operator"
                label="Operator"
                :items="operators"
                :disabled="operators.length === 0"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                clearable
                class="pt-0"
                v-model="editItem.notes"
                @keypress="allowAlphaNumOnly($event)"
                @keyup="editItem.notes = toAlphaNumOnly(editItem.notes)"
                label="Notes"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="primary"
            class="white--text mb-3"
            :disabled="!saveEnabled"
            @click="editItem.oldGroupName != null ? showModifyConfirmDialog = true : saveGroup()">
            Save
          </v-btn>
          <v-btn
            color="secondary"
            class="mb-3 mr-4"
            @click="closeModifyDialog()">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <v-dialog v-model="showModifyConfirmDialog" persistent max-width="350">
      <v-card color="cardbackground">
        <v-card-title class="text-h5">Save Group Changes?</v-card-title>
        <v-card-text class="d-flex">
          <div>
            <div class="primary--text text-subtitle-1">Old</div>
            <ul class="pl-4 mr-2" style="min-width:145px; border-top:1px solid">
              <li><b>Farm:</b> {{oldModifyItem.farm}}</li>
              <li><b>Line:</b> {{oldModifyItem.line }}</li>
              <li><b>SourceMG:</b> {{oldModifyItem.mg}}</li>
              <!-- <li><b>House:</b> {{oldModifyItem.house}}</li> -->
              <li><b>Operator:</b> {{ oldModifyItem.operator }}</li>
              <li><b>Date:</b> {{oldModifyItem.date}}</li>
              <li><b>Notes:</b> {{oldModifyItem.notes}}</li>
            </ul>
          </div>
          <v-spacer />
          <div class="ml-2">
            <div class="primary--text text-subtitle-1">New</div>
            <ul class="pl-4 mr-2" style="min-width:145px; border-top:1px solid">
              <li :style="changeBackgroundColor(editItem.farm != oldModifyItem.farm )"><b>Farm:</b> {{editItem.farm}}</li>
              <li :style="changeBackgroundColor(editItem.line != oldModifyItem.line)"><b>Line:</b> {{editItem.line}}</li>
              <li :style="changeBackgroundColor(editItem.mg != oldModifyItem.mg)"><b>Source MG:</b> {{editItem.mg}}</li>
              <!-- <li :style="changeBackgroundColor(editItem.house != oldModifyItem.house)"><b>House:</b> {{editItem.house}}</li> -->
              <li :style="changeBackgroundColor(editItem.operator != oldModifyItem.operator)"><b>Operator:</b> {{ editItem.operator }}</li>
              <li :style="changeBackgroundColor(editItem.date != oldModifyItem.date)"><b>Date:</b> {{editItem.date}}</li>
              <li :style="`${changeBackgroundColor(editItem.notes != oldModifyItem.notes)}`"><b>Notes:</b> {{editItem.notes}}</li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" class="white--text" @click="saveGroup()">Save</v-btn>
          <v-btn color="secondary" @click="showModifyConfirmDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDeleteDialog" persistent max-width="350">
      <v-card  color="cardbackground">
        <v-card-title class="text-h5">Confirm Delete</v-card-title>
        <v-card-text>Is it okay to delete {{ groupToDelete }}?</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" class="white--text" @click="deleteGroup()">Yes</v-btn>
          <v-btn color="secondary" @click="showDeleteDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showUploadDialog" persistent max-width="350">
      <v-card  color="cardbackground">
        <v-card-title class="text-h5">Confirm Upload</v-card-title>
        <v-card-text  v-if="selectedGroup">
          <div>Upload {{ selectedGroup.groupName }}?</div>
          <ul class="mt-2">
            <li><b>Egg Vision Count:</b> {{ selectedGroup.trays.length }}</li>
            <li><b>Created:</b> {{ selectedGroup.date }}</li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" class="white--text" @click="uploadVisionGroup()">Upload</v-btn>
          <v-btn color="secondary" @click="showUploadDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="isBusy">
      <v-row>
        <span class="text-h4" color="overlaytext">
          {{ overlayMessage }}
        </span>
      </v-row>
      <v-row>
        <v-progress-linear
          model-value="40"
          color="primary"
          label-position="bottom"
          hide-value
          indeterminate>
        </v-progress-linear>
      </v-row>
    </v-overlay>
  </div>
</template>
<script>
import OfflineStorage from '../utils/offlineStorage'
import { mapState } from 'vuex'
import eggApi from '../api/eggApi'
import RealSenseCameraApi from '../api/realSenseCameraApi';

export default {
  data() {
    return {
      deviceName: "",
      eggVisionGroups: [],
      cameraApi: new RealSenseCameraApi(),
      archivedEggVisionGroups: [],
      overlayMessage: "",
      isBusy: false,
      groupToDelete: null,
      showModifyDialog: false,
      showModifyConfirmDialog: false,
      showDeleteDialog: false,
      showUploadDialog: false,
      editItem: {},
      selectedGroup: null,
      showDetail: []
    }
  },

  async created() {
    try {
      this.deviceName = await OfflineStorage.getItem('deviceName');
      this.eggVisionGroups = await OfflineStorage.getItem('eggVisionGroups');
      if (this.eggVisionGroups == null) this.eggVisionGroups = [];

      this.archivedEggVisionGroups = await OfflineStorage.getItem('archivedEggVisionGroups');
      if (this.archivedEggVisionGroups == null) this.archivedEggVisionGroups = [];
      else await this.removeOldEggVisionGroups();
    } catch(error) {
      this.$root.showNoticeError(error.message);
    }
  },

  computed: {
    ...mapState(['settings', 'isOnline']),
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    currentFarm() {
      return this.settings.currentFarm;
    },
    lines() {
      if (!this.settings.farmLines) return [];
      var lines = this.settings.farmLines;
      return lines.map(line => line.lineCode);
    },
    mgs() {
      if (!this.settings.farmMiniGens || !this.editItem.line) return [];
      var mgs = this.settings.farmMiniGens.filter(mg => mg.lineCode === this.editItem.line);
      return mgs.map(mg => mg.miniGenerationNum).sort((a,b) => b - a);
    },
    houses() {
      if (!this.settings.farmHouses) return [];
      var uniqueHouseNames = this.settings.farmHouses.map(house => house.houseCode)
           .filter((house, i, list) => list.indexOf(house) === i);
      return uniqueHouseNames;
    },
    operators(){
      if (!this.settings.farmVisionOperators) return [];
      var operatorNames = this.settings.farmVisionOperators.map(operator => operator.operatorName);
      return operatorNames;
    },
    oldModifyItem() {
      var oldItem = this.eggVisionGroups.find(x => x.groupName === this.editItem.oldGroupName);
      return oldItem == null ? {} : oldItem;
    },
    saveEnabled() {
      const item = this.editItem;
      if (item.farm && item.line && item.mg)
        return true;
      else
        return false;
    }
  },

  methods: {
    addGroup() {
      const date = new Date();
      this.editItem = {
        deviceName: this.deviceName,
        checkWingband: false,
        oldGroupName: null,
        groupName: null,
        operatorId: null,
        farm: this.currentFarm,
        line: null,
        mg: null,
        // house: null,
        operator: null,
        date: date,
        notes: null,
        trays: []
      };

      this.showModifyDialog = true;
    },
    allowAlphaNumOnly(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if(/^[A-Za-z0-9 ]+$/.test(char)) return true; // Match with regex 
      else e.preventDefault(); // If not match, don't add to input text
    },
    changeBackgroundColor(isChanged) {
      if (!isChanged) return '';
      if (this.$vuetify.theme.dark)
        return 'background-color: gray';
      else
        return 'background-color:yellow';
    },
    closeModifyDialog() {
      this.showModifyDialog = false;
      this.showModifyConfirmDialog = false;
    },
    confirmDeleteGroup(item) {
      this.showDeleteDialog = true;
      this.groupToDelete = item.groupName;
    },
    daysDiff(firstDate, secondDate) {
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
      return diffDays;
    },
    async deleteGroup() {
      try {
        const index = this.eggVisionGroups.findIndex(x => x.groupName === this.groupToDelete);

        //* Add group to archived groups.
        this.eggVisionGroups[index].deleteDate = new Date();
        this.eggVisionGroups[index].trays.forEach(tray => {
          tray.sampleImage1 = "";
          tray.sampleImage2 = "";
        });
        this.archivedEggVisionGroups.push(this.eggVisionGroups[index]);
        await OfflineStorage.setItem('archivedEggVisionGroups', this.archivedEggVisionGroups);

        //* Remove group from active groups.
        this.eggVisionGroups.splice(index, 1);
        await OfflineStorage.setItem('eggVisionGroups', this.eggVisionGroups);

        this.$root.showNoticeSuccess('Group Deleted Successfully');
        this.showDeleteDialog = false;
      } catch (error) {
        this.$root.showNoticeError(error.message);
      }
    },
    editGroup(item) {
      this.editItem = JSON.parse(JSON.stringify(item));
      this.editItem.oldGroupName = this.editItem.groupName;
      this.showModifyDialog = true;
    },
    formatDate(dt) {
      dt = new Date(dt);

      const year  = dt.getFullYear();
      const month = dt.toLocaleDateString(undefined, { month: 'short'}).toUpperCase()
      const day   = dt.getDate().toString().padStart(2, "0");
      const date = `${year}-${month}-${day}`;

      return date;
    },
    goToCollectionPage(item) {
      this.$router.push({ name: 'Egg Vision', params: {groupName: item.groupName} });
    },
    goToSettingsPage() {
      this.$router.push({ path: 'settings'});
    },
    isDeleteGroupDisabled(item) {
      if (item.farm != this.currentFarm) return true;
      if (this.settings.userContext.contextName == 'ADMIN')
        return false;
      else if (this.settings.userContext.contextName == 'MANAGER') {
        let farms = this.settings.userContext.contextValue.split(',');
        if (farms.find(f => f == this.currentFarm))
        return false;
      }
      return true;
    },
    isUploadDisabled(item) {
      if (!this.isOnline) return true;
      if (item.trays == null) return true;
      if (item.trays.length === 0) return true;
      return false;
    },
    async saveGroup() {
      try {
        let groupName = `${this.editItem.farm}_${this.editItem.line}_${this.editItem.mg}_${this.formatDate(this.editItem.date)}`;
        if(!this.editItem.clientUid) this.editItem.clientUid = crypto.randomUUID();
        const eggGroup = {
          deviceName: this.deviceName,
          clientUid: this.editItem.clientUid,
          groupName: groupName,
          operatorId: this.editItem.operatorId,
          farm: this.editItem.farm,
          line: this.editItem.line,
          mg: this.editItem.mg,
          // house: this.editItem.house,
          operator: this.editItem.operator,
          date: this.editItem.date,
          notes: this.editItem.notes ? this.editItem.notes: '',
          trays: this.editItem.trays
        }

        if (this.editItem.oldGroupName == null){
          const items = this.eggVisionGroups.filter(x => x.groupName === groupName);
          if (items.length > 0) {
            throw new Error(`Duplicate Group. ${groupName} already exists.`);
          }
          this.eggVisionGroups.push(eggGroup);
        }
        else {
          const items = this.eggVisionGroups.filter(x => x.groupName === groupName);
          if (this.editItem.oldGroupName !== groupName && items.length > 0) {
            throw new Error(`Duplicate Group. ${groupName} already exists.`);
          }
          const itemIndex = this.eggVisionGroups.findIndex(x => x.groupName === this.editItem.oldGroupName);
          this.eggVisionGroups[itemIndex] = eggGroup;
          // deep clone to force computed values to reset
          this.eggVisionGroups = JSON.parse(JSON.stringify(this.eggVisionGroups));
        }
        await OfflineStorage.setItem('eggVisionGroups', this.eggVisionGroups);
        this.closeModifyDialog();
      } catch(error) {
        this.$root.showNoticeError(error.message);
      }
    },  
    navigateBack() {
      this.$router.replace({ path: '/' });
    },
    async removeOldEggVisionGroups() {
      let numToRemove = 0;

      const oldGroups = this.archivedEggVisionGroups.filter(group => {
        let now =  new Date();
        let diffDays = this.daysDiff(now, group.uploadDate);
        if (diffDays > 14) {
          numToRemove ++;
          return false;
        }
        return true;
      });
        
      if (numToRemove > 0) {
        this.archivedEggVisionGroups = oldGroups;
        await OfflineStorage.setItem('archivedEggVisionGroups', this.archivedEggVisionGroups);
      }

      console.log(`Removed ${numToRemove} old Egg Vision Groups.`); // eslint-disable-line no-console
    },
    toAlphaNumOnly(value) {
      if (value == null) return;
      value = value.toUpperCase();
      value = value.replace(/[^A-Z0-9\s!?]/g,'');
      return value;
    },
    toggleCardDetails(index) {
      this.showDetail[index] = !this.showDetail[index];
      this.$forceUpdate();
    },
    async uploadVisionGroup() {
     try {
        if (this.isBusy) return; // avoid duplicate uploads (possible double click)
        this.isBusy = true;
        this.showUploadDialog = false;
        this.overlayMessage = "Removing old Egg Vision Groups."
        await this.removeOldEggVisionGroups();
        
        if (this.selectedGroup.clientUid == null) { // shouldn't happen unless data created before version 1.0.1
          this.selectedGroup.clientUid = crypto.randomUUID();
          await OfflineStorage.setItem('eggVisionGroups', this.eggVisionGroups);
        }

        var uploadGroup = JSON.parse(JSON.stringify(this.selectedGroup));

        delete uploadGroup.currentTrays; // This was added to some by accident. Delete this later after data is cleaned up.

        for(const tray of uploadGroup.trays)
        {
          tray.sampleImage1 = "";
          tray.sampleImage2 = "";
          this.overlayMessage = `Uploading images for ${tray.base_file_name1}`;
          let images1 = await this.cameraApi.loadImages(tray.base_file_name1);
          let imageArray1 = [];
          imageArray1.push({FileName: tray.base_file_name1 + "_proc.png", File: images1.Proc});
          imageArray1.push({FileName: tray.base_file_name1 + "_c.png", File: images1.Color});
          imageArray1.push({FileName: tray.base_file_name1 + "_ad.tiff", File: images1.Depth});
          imageArray1.push({FileName: tray.base_file_name1 + "_acd.png", File: images1.ColorizedDepth});
          imageArray1.push({FileName: tray.base_file_name1 + "_ad_params.json", File: JSON.stringify(images1.Params)});
          await eggApi.uploadFiles(imageArray1);

          this.overlayMessage = `Uploading images for ${tray.base_file_name2}`;
          let images2 = await this.cameraApi.loadImages(tray.base_file_name2);
          let imageArray2 = [];
          imageArray2.push({FileName: tray.base_file_name2 + "_proc.png", File: images2.Proc});
          imageArray2.push({FileName: tray.base_file_name2 + "_c.png", File: images2.Color});
          imageArray2.push({FileName: tray.base_file_name2 + "_ad.tiff", File: images2.Depth});
          imageArray2.push({FileName: tray.base_file_name2 + "_acd.png", File: images2.ColorizedDepth});
          imageArray2.push({FileName: tray.base_file_name2 + "_ad_params.json", File: JSON.stringify(images2.Params)});
          await eggApi.uploadFiles(imageArray2);
        }

        this.overlayMessage = "Uploading group data.";
        var uploadDateTime = await eggApi.addVisionGroup(uploadGroup);

        this.overlayMessage = "Deleting older files.";
        await this.cameraApi.deleteOldFiles();
        this.overlayMessage = "Marking files as uploaded.";
        await this.cameraApi.markUpload(uploadGroup.trays[0].base_file_name1);
        this.overlayMessage = "Final cleanup.";

        //* Add group to archived groups.
        uploadGroup.uploadDate = uploadDateTime;
        this.archivedEggVisionGroups.push(uploadGroup);
        await OfflineStorage.setItem('archivedEggVisionGroups', this.archivedEggVisionGroups);

        //* Remove group from active groups.
        const ndx = this.eggVisionGroups.findIndex(e => e === this.selectedGroup);
        this.eggVisionGroups.splice(ndx, 1);
        await OfflineStorage.setItem('eggVisionGroups', this.eggVisionGroups);
        this.$root.showNoticeSuccess(`Egg Vision Group uploaded successfully.`);
      } catch(error) {
        console.log(error); // eslint-disable-line no-console
        this.$root.showNoticeError(error.message);
      }
      finally {
        this.isBusy = false;
      }
    }
  }
}
</script>
<style scoped>
  .side-by-side li {
    display: block;
    float: left;
    width: 140px;
    margin: 2px;
  }
  .single li {
    display: block;
    float: left;
    margin: 2px;
  }
  .truncate {
    max-width: 215px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>